module.exports = lvflanders.bar.shared;